import React, { useEffect, useMemo, useState } from "react";

export const LayoutContext = React.createContext();

const DESKTOP_LIMIT_WIDTH = 991;

export const LayoutProvider = (props) => {
    const [breadcrumbs, setBreadcrumbs] = useState([]);
    const [layoutConfig, setLayoutConfig] = useState({
        ripple: false,
        inputStyle: "outlined",
        menuMode: "static",
        menuTheme: "colorScheme",
        colorScheme: "light",
        theme: "indigo",
        scale: 14
    });

    const [layoutState, setLayoutState] = useState({
        staticMenuDesktopInactive: false,
        overlayMenuActive: false,
        overlaySubmenuActive: false,
        profileSidebarVisible: false,
        configSidebarVisible: false,
        staticMenuMobileActive: false,
        menuHoverActive: false,
        resetMenu: false
    });

    const { auth } = props;

    useEffect(() => {
        setLayoutState({
            staticMenuDesktopInactive: false,
            overlayMenuActive: false,
            overlaySubmenuActive: false,
            profileSidebarVisible: false,
            configSidebarVisible: false,
            staticMenuMobileActive: false,
            menuHoverActive: false,
            resetMenu: false
        });
    }, [auth]);

    const value = useMemo(() => {
        const onMenuToggle = () => {
            if (isOverlay()) {
                setLayoutState((prevLayoutState) => ({ ...prevLayoutState, overlayMenuActive: !prevLayoutState.overlayMenuActive }));
            }

            if (isDesktop()) {
                setLayoutState((prevLayoutState) => ({ ...prevLayoutState, staticMenuDesktopInactive: !prevLayoutState.staticMenuDesktopInactive }));
            } else {
                setLayoutState((prevLayoutState) => ({ ...prevLayoutState, staticMenuMobileActive: !prevLayoutState.staticMenuMobileActive }));
            }
        };

        const showProfileSidebar = () => {
            setLayoutState((prevLayoutState) => ({ ...prevLayoutState, profileSidebarVisible: !prevLayoutState.profileSidebarVisible }));
        };

        const isOverlay = () => {
            return layoutConfig.menuMode === "overlay";
        };

        const isSlim = () => {
            return layoutConfig.menuMode === "slim";
        };

        const isHorizontal = () => {
            return layoutConfig.menuMode === "horizontal";
        };

        const isDesktop = () => {
            return globalThis.innerWidth > DESKTOP_LIMIT_WIDTH;
        };

        return {
            layoutConfig,
            setLayoutConfig,
            layoutState,
            setLayoutState,
            onMenuToggle,
            showProfileSidebar,
            isSlim,
            isHorizontal,
            isDesktop,
            breadcrumbs,
            setBreadcrumbs
        };
    }, [layoutConfig, layoutState, breadcrumbs]);

    return (
        <LayoutContext.Provider value={value}>
            <>
                {props.children}
            </>
        </LayoutContext.Provider>
    );
};
